export const AUTH_SIGN_IN = "AUTH_SIGN_IN";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const AUTH_STATUS = "AUTH_STATUS";
export const AUTH_SET_USER = "AUTH_SET_USER"; // WNEH SETTING USER FROM LOCALSTORAGE
